import * as Sentry from "@sentry/react";
import { useCallback, useEffect, useRef, useState } from "react";
import React from "react";
import { useParams } from "react-router-dom";

import ContractList from "../../components/user/ContractList";
import Feedbacks from "../../components/user/Feedbacks";
// components
import { ImageUploader } from "../../components/userProfile/personalData/imageUploader";
// apis
import { getBasicUserDetailsById } from "../../setup/api/services/user";
// types
import { IUserInfoResponseData } from "../../setup/api/services/user/models";
import { ATTEMPTS } from "./ constants";
// providers context
import Tabbar from "./Tabbar";
// styles
import styles from "./user.module.scss";

export enum SelectedTab {
  CONTRACTS_TAB = "CONTRACTS_TAB",
  FEEDBACK_TAB = "FEEDBACK_TAB",
}
const UserProfile = (): JSX.Element => {
  const { id } = useParams();
  const [selectedTab, setSelectedTab] = useState<SelectedTab>(
    SelectedTab.CONTRACTS_TAB
  );

  const [userDetails, setUserDetials] = useState<
    IUserInfoResponseData | undefined
  >(undefined);
  const attempts = useRef<number>(0);

  const fetchUserDetails = useCallback(async (userId: number) => {
    if (userId) {
      try {
        const response = await getBasicUserDetailsById(Number(userId), true);
        setUserDetials(response.data);
      } catch (error) {
        attempts.current = attempts?.current + 1;
        if (attempts.current < ATTEMPTS) {
          setTimeout(() => {
            fetchUserDetails(userId);
          }, 500);
        }
        Sentry.captureException(error);
        console.error("error", error);
      }
    }
  }, []);

  useEffect(() => {
    if (id) {
      fetchUserDetails(Number(id));
    }
  }, [fetchUserDetails, id]);

  const PageDisplay = useCallback(() => {
    if (id && userDetails) {
      switch (selectedTab) {
        case SelectedTab.CONTRACTS_TAB:
          return <ContractList userId={String(id)} />;
        case SelectedTab.FEEDBACK_TAB:
          return <Feedbacks userDetails={userDetails} userId={String(id)} />;
        default:
          return <ContractList userId={String(id)} />;
      }
    } else {
      return <></>;
    }
  }, [id, selectedTab, userDetails]);

  const handleSelection = useCallback((selected: SelectedTab) => {
    setSelectedTab(selected);
  }, []);

  const renderTop = useCallback(
    () => (
      <div className={styles.top_section}>
        <div className={styles.profile_section}>
          <div className={styles.image_uploader}>
            <ImageUploader
              imageUploading={false}
              imageUrl={userDetails?.profile?.photoUrl}
              nationalIdVerified={userDetails?.nationalIdVerified}
              showVerification={true}
            />
          </div>
          <div className={styles.user_details}>
            <h2 className={styles["mt8"]}>
              {userDetails?.profile?.fullName || ""}
            </h2>
          </div>
        </div>
      </div>
    ),
    [
      userDetails?.nationalIdVerified,
      userDetails?.profile?.fullName,
      userDetails?.profile?.photoUrl,
    ]
  );

  const renderTabbar = useCallback(
    () => (
      <Tabbar selectedTab={selectedTab} handleSelection={handleSelection} />
    ),
    [handleSelection, selectedTab]
  );

  return (
    <div className={styles.profile_container}>
      {renderTop()}
      {renderTabbar()}
      {PageDisplay()}
    </div>
  );
};

export default UserProfile;
